import { useEffect } from "react";
import { prefetchPublicPlans } from "../utils/plansApi";
import { prefetchPublicFaqs } from "../utils/faqsApi";
import Header from "../components/layout/Header";
import Hero from "../components/sections/landingPage/Hero";
import MainFeatures from "../components/sections/landingPage/MainFeatures";
import HowItWorks from "../components/sections/landingPage/HowItWorks";
import TargetAudience from "../components/sections/landingPage/TargetAudience";
import PricingFaqShadedGroup from "../components/sections/landingPage/PricingFaqShadedGroup";
import Footer from "../components/layout/Footer";

function LandingPage() {
  useEffect(() => {
    prefetchPublicPlans();
    prefetchPublicFaqs();
  }, []);

  return (
    <div className="min-h-screen bg-transparent clip-x-visible-y">
      <Header overlay />
      <main className="app-page-content clip-x-visible-y">
        <Hero />
        <MainFeatures />
        <HowItWorks />
        <TargetAudience />
        <PricingFaqShadedGroup />
      </main>
      <Footer />
    </div>
  );
}

export default LandingPage;
